import {
    FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES,
    FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES_FETCHING,
    FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES_SUCCESS,
    FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES_FAIL,
    UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES,
    UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES_UPDATING,
    UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES_SUCCESS,
    UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES_FAIL
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    data: {},
    demographicComparePreferencesFetching: false,
    demographicComparePreferencesFetchFail: false,
    demographicComparePreferencesUpdateUpdating: false,
    demographicComparePreferencesUpdateFail: false
};

// ======= Fetching Handlers =======
const fetchDemographicComparePreferencesFetching = (state) => {
    return {
        ...state,
        demographicComparePreferencesFetching: true,
        demographicComparePreferencesFetchFail: false
    };
};

const fetchDemographicComparePreferencesSuccess = (state, action) => {
    return {
        ...state,
        data: action.data,
        demographicComparePreferencesFetching: false,
        demographicComparePreferencesFetchFail: false
    };
};

const fetchDemographicComparePreferencesFail = (state) => {
    return {
        ...state,
        demographicComparePreferencesFetching: false,
        demographicComparePreferencesFetchFail: true
    };
};

// ======= Updating Handlers =======
const updateDemographicComparePreferencesUpdating = (state) => {
    return {
        ...state,
        demographicComparePreferencesUpdateUpdating: true,
        demographicComparePreferencesUpdateFail: false
    };
};

const updateDemographicComparePreferencesSuccess = (state, action) => {
    return {
        ...state,
        data: action.data,
        demographicComparePreferencesUpdateUpdating: false,
        demographicComparePreferencesUpdateFail: false
    };
};

const updateDemographicComparePreferencesFail = (state) => {
    return {
        ...state,
        demographicComparePreferencesUpdateUpdating: false,
        demographicComparePreferencesUpdateFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES_FETCHING]: fetchDemographicComparePreferencesFetching,
    [FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES_SUCCESS]: fetchDemographicComparePreferencesSuccess,
    [FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES_FAIL]: fetchDemographicComparePreferencesFail,
    [UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES_UPDATING]: updateDemographicComparePreferencesUpdating,
    [UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES_SUCCESS]: updateDemographicComparePreferencesSuccess,
    [UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES_FAIL]: updateDemographicComparePreferencesFail
};

// ======= Default Action =======
export default function demographicComparePreferences(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchDemographicComparePreferences(evictCache) {
    return {
        type: FETCH_DEMOGRAPHIC_COMPARE_PREFERENCES,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function updateDemographicComparePreferences(newPreferences) {
    return {
        type: UPDATE_DEMOGRAPHIC_COMPARE_PREFERENCES,
        newPreferences: newPreferences
    };
}

// ======= Selectors =======
export const getDemographicComparePreferences = (state) => {
    return state.demographicComparePreferences.data ? state.demographicComparePreferences.data : null;
};

export const isDemographicComparePreferencesFetching = (state) => {
    return state.demographicComparePreferences.demographicComparePreferencesFetching;
};

export const didDemographicComparePreferencesFetchFail = (state) => {
    return state.demographicComparePreferences.demographicComparePreferencesFetchFail;
};

export const isDemographicComparePreferencesUpdateUpdating = (state) => {
    return state.demographicComparePreferences.demographicComparePreferencesUpdateUpdating;
};

export const didDemographicComparePreferencesUpdateFail = (state) => {
    return state.demographicComparePreferences.demographicComparePreferencesUpdateFail;
};
